import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import { selectCss } from "../reuseables/native.comp";
import { LabelAndInput } from "../reuseables/form.comp";

export function Availability({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();

  return (
    <section data-type="section">
      <h3>{t(msg.product.availability)}</h3>

      <select className={selectCss} {...methods.register("availability")}>
        <option value="in">{t(msg.product.inStock)}</option>
        <option value="out">{t(msg.product.outOfStock)}</option>
      </select>
      <div className="my-2">
        <LabelAndInput type="date" register={methods.register} fieldName="stockReadyDate" label={t(msg.product.stockReadyDate)} />
        {/* <label>
          <p>{t(msg.product.stockReadyDate)}</p>

          <input type="date" {...methods.register("stockReadyDate")} />
        </label> */}
      </div>
    </section>
  );
}
